import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

const googleClientId =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  process.env.GOOGLE_CLIENT_ID ||
  "309799710390-72nacmf9gol2k9faeqjmk41vb4ngd32l.apps.googleusercontent.com";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <BrowserRouter>
        <App />
        <ToastContainer position="top-left" autoClose={3000} />
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
